// extracted by css-extract-rspack-plugin
export default {"betaLabel":"RepoIssuesSidebar-module__betaLabel__IcYmL","divider":"RepoIssuesSidebar-module__divider__kISoG"};